import { CaseRunClient, MaxLrAicCaseRunModel } from "@app/api2/api";
import React from "react";
import { BPDataTable3 } from "../../Common/DataTable/BPDataTable3";
import { BPColumn } from "@common/BPReactTable";
import { yesNo, toSci } from "@common/Utils";
import { Grid, GridColumn, GridRow } from "@/components/bp/bp-ui";

interface IAicCalculationsProps {
    forPrint?: boolean;
    isDeconv: boolean;
    labId: number;
    caseId: number;
    caseRunId: number;
    separateHpHd: boolean;
}

export const AicCalculations: React.FunctionComponent<IAicCalculationsProps> = ({ forPrint, labId, caseId, caseRunId, isDeconv, separateHpHd }) => {
    const caseRunClient = new CaseRunClient()
    const t = window.translation;

    return <>
        {!separateHpHd &&
            <BPDataTable3
                forPrint={forPrint}
                defaultSortAsc={false}
                defaultSortField="adjLogLik"
                dataSource={(params) => {
                    return caseRunClient.getMaxLrAicCalculations(labId, caseId, caseRunId, params.perPage, params.page, params.sortBy, params.sortDirection);
                }}
                columns={[
                    { Header: t.caseRunView.aicCalcNumberOfContributors, accessor: 'noc' },
                    { Header: t.caseRunView.aicCalcUseDegradation, accessor: 'modelDegrad', Cell: cell => yesNo(cell.value) },
                    { Header: t.caseRunView.aicCalcUseBwStutter, accessor: 'modelBWstutt', Cell: cell => yesNo(cell.value) },
                    { Header: t.caseRunView.aicCalcUseFwStutter, accessor: 'modelFWstutt', Cell: cell => yesNo(cell.value) },
                    { Header: t.caseRunView.aicCalcLogLik, accessor: 'logLik', Cell: cell => toSci(cell.value) },
                    { Header: t.caseRunView.aicCalcAdjLogLik, accessor: 'adjLogLik', Cell: cell => toSci(cell.value) },
                    ...!isDeconv ? [{ Header: t.caseRunView.aicCalcLog10LR, accessor: 'log10LR' }] : [],
                    ...!isDeconv ? [{ Header: t.caseRunView.aicCalcMxPOI, accessor: 'mxPOI' }] : [],
                    ...!isDeconv ? [{ Header: t.caseRunView.aicCalcSignifHp, accessor: 'signifHp' }] : [],
                    ...!isDeconv ? [{ Header: t.caseRunView.aicCalcSignifHd, accessor: 'signifHd' }] : [],
                ] as Array<BPColumn<MaxLrAicCaseRunModel>>} />}
        {separateHpHd &&
            <Grid>
                <GridRow columns={2}>
                    <GridColumn>
                        <h3>H<sub>p</sub></h3>
                        <BPDataTable3
                            forPrint={forPrint}
                            defaultSortAsc={false}
                            defaultSortField="adjLogLikHp"
                            dataSource={(params) => {
                                return caseRunClient.getMaxLrAicCalculations(labId, caseId, caseRunId, params.perPage, params.page, params.sortBy, params.sortDirection);
                            }}
                            columns={[
                                { Header: t.caseRunView.aicCalcNumberOfContributors, accessor: 'noc', tableHeaderProps: { style: { textWrap: "wrap" } } },
                                { Header: t.caseRunView.aicCalcUseDegradation, accessor: 'modelDegrad', Cell: cell => yesNo(cell.value), tableHeaderProps: { style: { textWrap: "wrap" } } },
                                { Header: t.caseRunView.aicCalcUseBwStutter, accessor: 'modelBWstutt', Cell: cell => yesNo(cell.value), tableHeaderProps: { style: { textWrap: "wrap" } } },
                                { Header: t.caseRunView.aicCalcUseFwStutter, accessor: 'modelFWstutt', Cell: cell => yesNo(cell.value), tableHeaderProps: { style: { textWrap: "wrap" } } },
                                { Header: t.caseRunView.aicCalcLogLik, id: 'logLikHp', accessor: 'hp', Cell: cell => toSci(cell.value.logLikelihood) },
                                { Header: t.caseRunView.aicCalcAdjLogLik, accessor: 'adjLogLikHp', Cell: cell => toSci(cell.value) },
                            ] as Array<BPColumn<MaxLrAicCaseRunModel>>} />
                    </GridColumn>
                    <GridColumn>
                        <h3>H<sub>d</sub></h3>
                        <BPDataTable3
                            forPrint={forPrint}
                            defaultSortAsc={false}
                            defaultSortField="adjLogLikHd"
                            dataSource={(params) => {
                                return caseRunClient.getMaxLrAicCalculations(labId, caseId, caseRunId, params.perPage, params.page, params.sortBy, params.sortDirection);
                            }}
                            columns={[
                                { Header: t.caseRunView.aicCalcNumberOfContributors, accessor: 'noc', tableHeaderProps: { style: { textWrap: "wrap" } } },
                                { Header: t.caseRunView.aicCalcUseDegradation, accessor: 'modelDegrad', Cell: cell => yesNo(cell.value), tableHeaderProps: { style: { textWrap: "wrap" } } },
                                { Header: t.caseRunView.aicCalcUseBwStutter, accessor: 'modelBWstutt', Cell: cell => yesNo(cell.value), tableHeaderProps: { style: { textWrap: "wrap" } } },
                                { Header: t.caseRunView.aicCalcUseFwStutter, accessor: 'modelFWstutt', Cell: cell => yesNo(cell.value), tableHeaderProps: { style: { textWrap: "wrap" } } },
                                { Header: t.caseRunView.aicCalcLogLik, id: 'logLikHd', accessor: 'hd', Cell: cell => toSci(cell.value.logLikelihood) },
                                { Header: t.caseRunView.aicCalcAdjLogLik, accessor: 'adjLogLikHd', Cell: cell => toSci(cell.value) },
                            ] as Array<BPColumn<MaxLrAicCaseRunModel>>} />

                    </GridColumn>
                </GridRow>
            </Grid>
        }
    </>
}
